var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var HttpService = /** @class */ (function () {
    function HttpService(optionService, responseService, routerService) {
        this.allowedMethods = [
            'GET', 'POST', 'PUT', 'PATCH', 'DELETE',
        ];
        this.optionService = optionService;
        this.responseService = responseService;
        this.routerService = routerService;
    }
    HttpService.prototype.get = function (e) {
        return this.http(e, 'GET');
    };
    HttpService.prototype.post = function (e) {
        return this.http(e, 'POST');
    };
    HttpService.prototype.http = function (e, method) {
        if (method === void 0) { method = 'GET'; }
        var endpoint = (e.parameter || {}).e || '';
        if (endpoint.substr(0, 1) !== '/') {
            endpoint = '/' + endpoint;
        }
        // methods
        var originalMethod = method;
        var allowMethodsWhenDoGet = this.optionService.get('allowMethodsWhenDoGet');
        if (method !== 'GET' || (method === 'GET' && allowMethodsWhenDoGet)) {
            var useMeMethod = (e.parameter || {}).method;
            method = useMeMethod ? useMeMethod.toUpperCase() : method;
            method = (this.allowedMethods.indexOf(method) < 0) ? originalMethod : method;
        }
        // request object
        var req = {
            query: e.parameter || {},
            params: e.parameter || {},
            body: {},
            data: {}
        };
        // body
        if (method === 'GET' && allowMethodsWhenDoGet) {
            try {
                req.body = JSON.parse((e.parameter || {}).body || '{}');
            }
            catch (error) {
                req.body = {};
            }
        }
        else {
            req.body = JSON.parse(e.postData ? e.postData.contents : '{}');
        }
        // response object
        var res = this.responseService;
        // execute handlers
        var handlers = this.routerService.route(method, endpoint);
        return this.execute(handlers, req, res);
    };
    HttpService.prototype.execute = function (handlers, req, res) {
        var _this = this;
        var handler = handlers.shift();
        if (!handler) {
            throw new Error('Invalid router handler!');
        }
        if (handlers.length < 1) {
            return handler(req, res);
        }
        else {
            var next = function (data) {
                if (data) {
                    if (!(data instanceof Object)) {
                        data = { value: data };
                    }
                    req.data = __assign({}, (req.data || {}), (data || {}));
                }
                return _this.execute(handlers, req, res);
            };
            return handler(req, res, next);
        }
    };
    return HttpService;
}());
export { HttpService };
